import type {
	CustomItem,
	DropEmpressesNftVideoType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropNftVideo = (
	item: Item | CustomItem
): item is DropEmpressesNftVideoType => {
	return !!(
		item &&
		item.__typename === 'Drop_Custom_Component' &&
		item.name === 'Drop_Empresses_NFT_Video'
	);
};
